module.exports = __webpack_public_path__ + "img/detail-icon-overview.0863053d.svg";